<template>
  <div class="fullWidth accessGroup fRow jStart aStart wrap">
    <div class="fRow fullWidth jStart aCenter firstRow"
      @click="selectAll">
      <select-indicator :size="24"
        :val="selectedChilds.length > 0" />
      <div class="tt">{{data.title}}</div>
    </div>
    <div class="childs fullWidth fRow jBetween aStart wrap"
      v-if="data.hasChild">
      <div class="child fRow aCenter"
        v-bind:class="{
        }"
        v-for="(i, x) in data.permissions" v-bind:key="x"
        @click="childSelect(i.id)">
        <select-indicator
          :size="16"
          :val="isInArray(i.id) !== -1" />
        <div class="t">{{i.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SelectIndicator from '@/components/SelectIndicator.vue';
import { EventBus } from '@/plugins/event-bus';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'initData'],
  data() {
    return {
      selectedChilds: [],
      initAccessId: '',
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  components: {
    SelectIndicator,
  },
  methods: {
    // new ↓
    parentSelect() {
      // console.log('select/deselect all childs of: ', item.id);
    },
    childSelect(id) {
      console.log('select ', id);
      const ind = this.isInArray(id);
      if (ind === -1) {
        this.selectedChilds.push(id);
      } else {
        this.selectedChilds.splice(ind, 1);
      }
    },
    isInArray(id) {
      return this.selectedChilds.indexOf(id);
    },
    selectAll() {
      const l = this.selectedChilds.length;
      const ll = this.data.permissions.length;
      if (l === ll) {
        this.selectedChilds = [];
      } else {
        this.selectedChilds = [];
        for (let i = 0; i < this.data.permissions.length; i += 1) {
          this.selectedChilds.push(this.data.permissions[i].id);
        }
      }
    },
    getAccessPermissions() {
      console.warn('start getting access permissions from: ', this.initAccessId);
      axios({
        method: 'get',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Accesses/permission/${this.initAccessId}`,
      }).then((response) => {
        if (response.data.isSuccess) {
          // age data.id === id yeki az group haye in response bood,
          // childs un bayad push beshe ro this.selectedChilds
          const p = response.data.data;
          for (let i = 0; i < p.length; i += 1) {
            if (p[i][0].parent.id === this.data.id) {
              const c = p[i];
              this.selectedChilds = [];
              for (let j = 0; j < c.length; j += 1) {
                console.log(c[j].id);
                this.childSelect(c[j].id);
              }
              console.error(this.selectedChilds);
              console.error('-------');
            }
          }
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
  },
  watch: {
    selectedChilds() {
      // console.error(this.selectedChilds);
      // console.error(this.data.permissions);
      // this.$emit('update', {
      //   childs: this.selectedChilds,
      //   parent: this.data.id,
      // });
    },
    init() {
      console.log(this.init);
    },
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      console.log('init access ---->', this.initData);
      const p = this.initData;
      for (let i = 0; i < p.length; i += 1) {
        if (p[i][0].parent.id === this.data.id) {
          const c = p[i];
          this.selectedChilds = [];
          for (let j = 0; j < c.length; j += 1) {
            console.log(c[j].id);
            this.childSelect(c[j].id);
          }
          console.error(this.selectedChilds);
          console.error('-------');
        }
      }
      EventBus.$on('getAll', () => {
        this.$emit('update', {
          childs: this.selectedChilds,
          parent: this.data.id,
        });
      });
      EventBus.$on('init', (item) => {
        // read id and push to this.selectedChilds
        this.initAccessId = item.id;
        console.log('init from accessGroup ↓');
        setTimeout(() => {
          this.getAccessPermissions();
        }, 1000);
      });
    });
  },
};
</script>

<style lang="scss" scoped>

  .accessGroup {
    border-radius: 16px;
    margin-bottom: 8px;
    border: solid 2px var(--normalText2);
    .firstRow {
      padding: 8px;
      .tt {
        font-size: 14px;
        font-weight: bold;
        text-align: right;
        color: var(--normalText);
      }
    }
    .childs {
      .child {
        padding: 8px 12px;
        width: 33.3333%;
        border-bottom: dashed 1px var(--normalText1);
        .t {
          font-size: 11px;
          text-align: right;
          color: var(--normalText);
        }
      }
      .child:hover {
        background-color: var(--normalText1);
      }
    }
  }
  .accessGroup.selected {
    border-color: var(--themeGreen) !important;
  }
</style>
